import React from 'react';
import './style/fonts.css';
import 'quill/dist/quill.snow.css';
import { setup } from 'goober';
import { shouldForwardProp } from 'goober/should-forward-prop';
setup(
    React.createElement,
    undefined,
    undefined,
    shouldForwardProp((prop) => {
        return prop['0'] !== '$';
    })
);
import { GlobalStyles } from './style';
import { Toaster } from 'react-hot-toast';
import 'swiper/css';
import '@vtbhome/juicyfront/styles/common.scss';
import '@vtbhome/juicyfront/styles/colors.scss';
import '@vtbhome/juicyfront/styles/mixins.scss';
import { Providers } from './providers';
import { AppRouter } from './router';
import 'dayjs/locale/ru';
import utc from 'dayjs/plugin/utc';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import dayjs from 'dayjs';

dayjs.locale('ru');
dayjs.extend(utc);
dayjs.extend(customParseFormat);

export const App: React.FC = () => {
    return (
        <React.StrictMode>
            <Providers>
                <Toaster position='top-right' />
                <GlobalStyles />
                <AppRouter />
            </Providers>
        </React.StrictMode>
    );
};
